
export const showSelectApproversSection = (activeApproval, currentStage) => {
    return activeApproval?.canSelectApprovers && currentStage?.status <= 1;
}

export const showApprovalDecisionSection = (activeApproval, currentStage, loggedUser) => {
    const approvalUser = currentStage?.approvers.find(a => a.userIdentity === loggedUser.identity || a.userIdentity === loggedUser.replacedUserId)
    return activeApproval?.formVisible && currentStage?.status === 2
        && (approvalUser?.status === 'NOTIFICATION_SENT' || activeApproval.canMasterReject || activeApproval.canMasterApprove);
}

export const canApprove = (currentStage, loggedUser) => {
    const approvalUser = currentStage?.approvers.find(a => a.userIdentity === loggedUser.identity || a.userIdentity === loggedUser.replacedUserId)
    return currentStage?.status === 2 && approvalUser?.status === 'NOTIFICATION_SENT';
}

export const canMasterApprove = (activeApproval, currentStage) => {
    return currentStage?.status === 2 && activeApproval.canMasterApprove;
}

export const canMasterReject = (activeApproval, currentStage) => {
    return currentStage?.status === 2 && activeApproval.canMasterReject;
}

export const canMasterReset = (activeApproval, currentStage) => {
    return currentStage?.status === 1 && activeApproval.canResetApproval;
}

export const canAddApprover = (approval, stage) => {
    return approval.canAddApprovers && stage.status <= 2 && stage.approvers?.length > 0;
}

export const canDeleteApprover = (approval, stage, approver) => {
    return approval.canDeleteApprovers && stage.status <= 2 && stage.approvers.length > 1 && stage.approvers.length > stage.minApproversAcceptedCount
        && (approver.status === 'NOTIFICATION_SENT' || approver.status === 'NOTIFICATION_NOT_SENT_YET');
}